<app-base-popup #basePopup (closed)="closed.emit()">
    <div class="sfp_contents padding16">
        <div class="sfp_header">{{lang.get('systems.labels.searchSystem')}}</div>
        <app-text-edit class="sfp_edit" (valueChanged)="systemToFind = $event" (enterClicked)="confirmSearch()" #phraseEdit></app-text-edit>
        <div class="sfp_description">{{lang.get('systems.labels.searchPhrase')}}</div>
        <div class="button sfp_button" (click)="confirmSearch()">{{lang.get('systems.buttons.search')}}</div>
    </div>
</app-base-popup>